import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { getAllParams, getNestedProp, replaceParam } from '@core/utilities/utilities.constants';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, takeUntil } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'formly-dynamic-template',
  template: `<div [innerHtml]="template" [attr.id]="props.id"></div>`,
})
export class DynamicFormlyTemplateTypeComponent extends FieldType implements OnInit, OnDestroy {
  template: any;
  private innerHtml = { content: null, template: null };
  private _destroy$ = new Subject<any>();

  constructor(private translateService: TranslateService, private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit(): void {
    this.parseTemplate(this.props.template);
    this.initContentSub();
    this.handleLanguageChange();
  }

  handleLanguageChange() {
    this.translateService.onLangChange
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => {
        this.parseTemplate(this.props.template);
      });
  }

  private getFieldValue(prop: string): string {
    return getNestedProp(this.field.model, prop) || '';
  }

  private parseTemplate(template: any): void {
    if (template) {
      let source = template;
      if (this.props.translate) {
        source = this.translateService.instant(template);
      }

      const params = getAllParams(source);

      params.forEach(param => {
        source = replaceParam(source, param, this.getFieldValue(param));
      });

      this.innerHtml = {
        template: source,
        content: this.props.safeHtml ? this.sanitizer.bypassSecurityTrustHtml(source) : source,
      };
    }

    this.template = this.innerHtml.content;
  }

  private initContentSub(): void {
    const updateContent: Observable<any> = this.props.updateContent;

    if (!updateContent) {
      return;
    }

    updateContent.pipe(untilDestroyed(this)).subscribe(value => {
      this.parseTemplate(value);
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next(null);
    this._destroy$.complete();
  }
}
